import { useState } from "react"
import { Box, TextField, Chip, Typography, Paper, Stack } from "@mui/material"
import { useApiService } from "../hooks/Api/useApiService"
import SimilarSkill from "./SimilarSkill"
import useTranslationSharie from "../hooks/Language/useTranslation"

const SimilarSkills = ({ skills = [] }) => {
  const [selected_skill, setSelectedSkill] = useState(null)
  const [inputSkill, setInputSkill] = useState("")
  const [filteredSkills, setFilteredSkills] = useState(skills)
  const [similarSkills, setSimilarSkills] = useState([]) // Store similar skills from API
  const [loading, setLoading] = useState(false) // Loading state for API requests
  const { postData } = useApiService()
  const t = useTranslationSharie()

  const handleChange = (event) => {
    const skill = event.target.value.toLowerCase()
    setInputSkill(event.target.value)

    if (!skill) {
      setFilteredSkills(skills) // Reset to all skills when input is cleared
    } else {
      setFilteredSkills(skills.filter((s) => s.name?.toLowerCase().includes(skill)))
    }
  }

  const handleSkillClick = async (skill) => {
    if (skill === selected_skill) {
      setSelectedSkill(null)
      setSimilarSkills([])
      return
    } // Deselect if already selected
    else setSelectedSkill(skill)
    setLoading(true) // Start loading

    try {
      // API call to fetch similar skills using the clicked skill
      postData("skills/getsimilarskills", { skill }).then((data) => {
        setSimilarSkills(data?.similarSkills || []) // Take the similar skills
      }) // Adjust the API endpoint and params as needed
    } catch (error) {
      console.error("Error fetching similar skills:", error)
    } finally {
      setLoading(false) // End loading
    }
  }

  return (
    <Paper
      elevation={4}
      sx={{
        p: 3,
        borderRadius: "0.8rem",
        width: "100%", // Set full width of the parent container
        mx: "auto", // Center horizontally
        mt: 4,
        m: 4,
        overflow: "hidden", // Prevents overflow if content exceeds width
      }}
    >
      <Box sx={{ width: "100%", mb: 2 }}>
        <TextField
          sx={{ width: "85%" }}
          label={t("Search for a similar skill")}
          variant='outlined'
          value={inputSkill}
          onChange={handleChange}
        />
      </Box>

      <Stack direction='row' spacing={1} flexWrap='wrap'>
        {filteredSkills.length > 0 ? (
          filteredSkills.map((skill) => (
            <Chip
              key={skill.name}
              label={skill.name}
              color='primary'
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                p: 0.5,
                cursor: "pointer",
                maxWidth: "150px", // Optional: limit the width of each chip
                overflow: "hidden", // Prevents overflow in chips
                textOverflow: "ellipsis", // Ensures chip text does not overflow
              }}
              onClick={() => handleSkillClick(skill)}
            />
          ))
        ) : (
          <Typography variant='body2' color='text.secondary'>
            {t("No similar skills found")}
          </Typography>
        )}
      </Stack>

      {/* Display similar skills in a vertical list of cards */}
      <Box sx={{ mt: 2 }}>
        {loading ? (
          <Typography variant='body2' color='text.secondary'>
            {t("Loading similar skills")}
          </Typography>
        ) : (
          similarSkills.length > 0 &&
          similarSkills.map((skill) => <SimilarSkill skill={skill} key={skill.name} />)
        )}
      </Box>
    </Paper>
  )
}

export default SimilarSkills
